export const navs = [
  { label: "Factory", path: "/factory" },
  { label: "Pool", path: "/pool" },
  { label: "Vault", path: "/automated-vault" },
  // { label: "Simulator", path: "/simulator" },
  { label: "Stats", path: "/statistics" },
];
